import React from 'react';
import { Typography } from 'antd';
import { EllipsisText } from '../Typo';

interface TextCellProps
  extends React.ComponentProps<typeof Typography.Paragraph> {}

const TextCell = (props: TextCellProps) => {
  return (
    <EllipsisText ellipsis={{ rows: 2, tooltip: props.children }} {...props} />
  );
};

export default TextCell;
